import { SyncEventType } from '../../enums/syncEventType';
import { RealtimeEvent } from './realtimeEvent';

export class EventIssuecardOpened implements RealtimeEvent {

  public readonly type = SyncEventType.ISSUECARD_OPENED;
  public issueId: number;
  public parentIssueId: number;
  public isSubissue: boolean;
  public isNewIssue: boolean;
  public position: any;
  public avatar: string;

  constructor(issueId: number, parentIssueId = null, isSubissue: boolean, position: any, avatar: string) {
    this.issueId = issueId;
    this.parentIssueId = parentIssueId;
    this.isSubissue = isSubissue;
    this.isNewIssue = (Number(this.issueId) < 0);
    this.position = position;
    this.avatar = avatar;
  }

  getPayload(): object {
    return {
      'issueId': this.issueId,
      'parentIssueId': this.parentIssueId,
      'isSubissue': this.isSubissue,
      'isNewIssue': this.isNewIssue,
      'position': this.position,
      'avatar': this.avatar
    };
  }

  static fromPayload(payload: any): EventIssuecardOpened {
    return new EventIssuecardOpened(
      payload['issueId'],
      payload['parentIssueId'],
      payload['isSubissue'],
      payload['position'],
      payload['avatar']
    );
  }

}

